import asArray from 'utils/arrays/asArray.util';
import fromAnyToBool from 'utils/converters/fromAnyToBool.util';

const createSorterForSalonList = (list) => {
  const array = asArray(list);

  return (a, b) => {
    const indexA = array.findIndex(({ id }) => id === a.id);
    const indexB = array.findIndex(({ id }) => id === b.id);

    if (indexA > -1 && indexB < 0) return -1;
    if (indexB > -1 && indexA < 0) return 1;
    if (indexA > -1 && indexB > -1) return indexA - indexB;

    return b.id - a.id;
  };
};

export const fromSalonListObjectToSalonsInfo = (maybeSalonList) => {
  const support = asArray(maybeSalonList?.response?.support);
  const isOk = fromAnyToBool(maybeSalonList?.ok);

  const supportCount = support.length;
  const isSupport = supportCount > 0;

  const manager = isSupport ? [...support] : asArray(maybeSalonList?.response?.manager);
  const managerCount = manager.length;

  const receptionist = isSupport ? [...support] : asArray(maybeSalonList?.response?.receptionist);
  const receptionistCount = receptionist.length;

  if (isSupport) {
    manager.sort(createSorterForSalonList(manager));
    receptionist.sort(createSorterForSalonList(receptionist));
  }

  return {
    isOk,
    isSupport,
    manager,
    receptionist,
    support,
    managerCount,
    receptionistCount,
    supportCount,
    hasRole: managerCount > 0 || receptionistCount > 0 || supportCount > 0,
    hasNoRole: !managerCount && !receptionistCount && !supportCount,
  };
};
